// components/EditPaymentTypeStep.jsx
import { CreditCard } from "lucide-react";

const paymentTypes = ["کارت به کارت", "دستگاه POS", "زرین پال", "نامعلوم"];

const EditPaymentTypeStep = ({ paymentType, onPaymentTypeChange }) => {
  return (
    <div className="bg-white rounded-2xl border border-slate-200 p-4 mt-6">
      <h4 className="text-sm font-bold text-slate-700 flex items-center gap-2 mb-3">
        <CreditCard className="w-4 h-4 text-purple-600" />
        نوع پرداخت
      </h4>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
        {paymentTypes.map((type) => (
          <button
            key={type}
            type="button"
            onClick={() => onPaymentTypeChange(type)}
            className={`px-4 py-3 rounded-xl border-2 transition-all text-sm font-medium ${
              paymentType === type
                ? "border-purple-600 bg-purple-50 text-purple-700 shadow-sm"
                : "border-slate-200 bg-white text-slate-600 hover:border-purple-200"
            }`}
          >
            {type}
          </button>
        ))}
      </div>
    </div>
  );
};

export default EditPaymentTypeStep;
